export default {
  disclaimerTextAlign: 'left',
  disclaimerColor: 'var(--base-brown)',
};

